export const userNameReg = /^[^\u4e00-\u9fa5]+$/
export const userName = {
	pattern: userNameReg,
	message: '不能输入中文字符',
}
export const caseNoReg = {
	pattern: /^[^\u4e00-\u9fa5]+$/,
	message: '不能输入中文字符',
}
export const taskRequest = {
	// 点号不匹配换行符
	pattern: /^(?:.|\s){0,200}$/,
	message: '最多200个字符',
}
export const contactPhonePattern = {
	pattern: /^(\d+-)?\d+$/,
	message: '限制20个字符限制数字和-',
}
export const mobilePhone = {
	pattern: /^1[3456789]\d{9}$/,
	message: '请输入正确的11位手机号码',
}

export const passwordReg = (function() {
	const lc = 'a-z'
	const uc = 'A-Z'
	const num = '0-9'
	const sym = '!"#$%&\'()*+,\\-./:;<=>?@[\\]^_`{}~'
	const min = 8
	const max = 16
	const arr = [
		// 排列组合,4选3
		[lc, uc, num],
		[lc, uc, sym],
		[lc, num, sym],
		[uc, num, sym],
	]
	let res = '^(?:'
	for (const [index, list] of arr.entries()) {
		if (index > 0) {
			res += '|'
		}
		for (const rule of list) {
			res += `(?=.*[${rule}])`
		}
	}
	res += `)[${lc}${uc}${num}${sym}]{${min},${max}}$`
	return new RegExp(res)
})()
